var map = {
	"./": 70511,
	"./dev": 40185,
	"./dev.ts": 40185,
	"./index": 70511,
	"./index.ts": 70511,
	"./prod": 5827,
	"./prod.ts": 5827,
	"./test": 5523,
	"./test.ts": 5523,
	"./uat": 77177,
	"./uat.ts": 77177
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 2978;